const Roles = Object.freeze({
    admin: 'ADMIN',
    citizen: 'CITIZEN',
    company: 'COMPANY',
})

export default Roles
